export interface EducationStoreState {
  visitedTutorials: { [key in TutorialKey]?: boolean }
}

export enum TutorialKey {
  GlucoseEducation = 'GlucoseEducation',
  CGMEducation = 'CGMEducation',
}
